<template>
  <div class="modal-container-component">
    <account-modal />
    <additional-settings-modal />
    <activation-modal />
    <bookmark-tour-start-modal />
    <change-password-modal />
    <delayed-purchase-modal />
    <edit-profile-modal />
    <exam-simulations-modal />
    <payment-error-modal />
    <profile-show-modal />
    <questions-tour-finish-modal />
    <questions-tour-start-modal />
    <rate-limit-reached-modal />
    <share-modal />
    <study-goal-set-modal />
    <study-goal-success-modal />
    <transitions-modal />
    <highlight-legend-modal />
    <qotd-modal />
    <update-payment-info-modal />
    <help-and-support-modal />
  </div>
</template>

<script>
import AccountModal from '@/components/modals/AccountModal.vue';
import ActivationModal from '@/components/modals/ActivationModal.vue';
import AdditionalSettingsModal from './AdditionalSettingsModal.vue';
import BookmarkTourStartModal from '@/components/modals/bookmark-tour-start-modal.vue';
import ChangePasswordModal from './ChangePasswordModal.vue';
import DelayedPurchaseModal from '@/components/modals/delayed-purchase-modal.vue';
import EditProfileModal from '@/components/modals/EditProfileModal.vue';
import ExamSimulationsModal from './ExamSimulationsModal.vue';
import HelpAndSupportModal from './HelpAndSupportModal.vue';
import HighlightLegendModal from '@/components/modals/highlight-legend-modal.vue';
import PaymentErrorModal from '@/components/modals/payment-error-modal.vue';
import ProfileShowModal from '@/components/modals/ProfileShowModal.vue';
import QotdModal from '@/components/modals/qotd-modal.vue';
import QuestionsTourFinishModal from '@/components/modals/questions-tour-finish-modal.vue';
import QuestionsTourStartModal from '@/components/modals/questions-tour-start-modal.vue';
import RateLimitReachedModal from '@/components/modals/rate-limit-reached-modal.vue';
import ShareModal from '@/components/modals/share-modal.vue';
import StudyGoalSetModal from '@/components/modals/study-goal-set-modal.vue';
import StudyGoalSuccessModal from '@/components/modals/study-goal-success-modal.vue';
import TransitionsModal from '@/components/modals/transitions-modal.vue';
import UpdatePaymentInfoModal from '@/components/modals/UpdatePaymentInfoModal.vue';

export default {
  components: {
    AccountModal,
    ActivationModal,
    AdditionalSettingsModal,
    BookmarkTourStartModal,
    ChangePasswordModal,
    DelayedPurchaseModal,
    EditProfileModal,
    ExamSimulationsModal,
    HighlightLegendModal,
    HelpAndSupportModal,
    PaymentErrorModal,
    ProfileShowModal,
    QotdModal,
    QuestionsTourFinishModal,
    QuestionsTourStartModal,
    RateLimitReachedModal,
    ShareModal,
    StudyGoalSetModal,
    StudyGoalSuccessModal,
    TransitionsModal,
    UpdatePaymentInfoModal,
  },
};
</script>
